import { Check, Palette } from "lucide-react";

import { useTheme } from "@/components/ThemeProvider";
import { THEME_OPTIONS } from "@/lib/themes";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui";

export function ModeToggle() {
  const { setTheme, theme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Palette className="h-[1.2rem] w-[1.2rem]" />
          <span className="sr-only">Choose theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {THEME_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.id}
            className="flex items-center gap-2"
            onClick={() => {
              setTheme(option.id);
            }}
          >
            <span
              aria-hidden="true"
              className="border-border h-3.5 w-3.5 rounded-full border"
              style={{ backgroundColor: option.previewColors[2] }}
            />
            <span className="flex-1">{option.shortLabel}</span>
            {theme === option.id ? <Check className="h-4 w-4" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
